module.exports = __webpack_public_path__ + "static/media/soviet_train_120x120.289f5a97.png";